var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 17.515 6.486 22 12 22C17.514 22 22 17.515 22 12C22 6.486 17.514 2 12 2C6.486 2 2 6.486 2 12Z",
    fill: "#E2E3E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77893 10.558C7.77893 10.749 7.85193 10.941 7.99793 11.087L11.4679 14.574C11.6089 14.715 11.7999 14.794 11.9999 14.794C12.1989 14.794 12.3899 14.715 12.5309 14.574L16.0029 11.087C16.2949 10.794 16.2949 10.32 16.0009 10.027C15.7069 9.73497 15.2319 9.73597 14.9399 10.029L11.9999 12.982L9.05993 10.029C8.76793 9.73597 8.29393 9.73497 7.99993 10.027C7.85193 10.173 7.77893 10.366 7.77893 10.558Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.12b5ff998758f8f6b45353af77b9486a.svg";
export { ForwardRef as ReactComponent };